import type { JSX, SVGProps } from 'react';
export default function SvgClose(props: SVGProps<SVGSVGElement>): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <svg viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
            <path d="M21.1049 22.1656L12.6196 13.6803C12.3297 13.3904 12.3297 12.9096 12.6196 12.6197C12.9095 12.3298 13.3903 12.3298 13.6802 12.6197L22.1655 21.105C22.4554 21.3949 22.4554 21.8757 22.1655 22.1656C21.8756 22.4555 21.3948 22.4555 21.1049 22.1656Z" />
            <path d="M12.6196 22.1656C12.3297 21.8757 12.3297 21.3949 12.6196 21.105L21.1049 12.6197C21.3948 12.3298 21.8757 12.3298 22.1656 12.6197C22.4555 12.9096 22.4555 13.3904 22.1656 13.6803L13.6803 22.1656C13.3904 22.4555 12.9096 22.4555 12.6196 22.1656Z" />
        </svg>
    );
}
